import globalConfig from './globalConfig';
const { global } = globalConfig;
let userAgent = (global.navigator && global.navigator.userAgent) || '';
let ua = userAgent.toLowerCase();

export let isAndroid = function () {
  return ua.indexOf('android') > -1;
};
export let isIOS = function () {
  // return !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
  return ua.indexOf('iphone') > -1;
};
export let isWinPhone = function () {
  return !!global.navigator.userAgent.match(/windows phone/i);
};
export let isIpad = function () {
  return (
    ua.indexOf('ipad') > -1 ||
    (global.navigator?.platform === 'MacIntel' && navigator?.maxTouchPoints > 1)
  );
};
export let isPhone = function () {
  return isAndroid() || isIOS() || isWinPhone() || isIpad();
};

export let isMobileChrome = function () {
  var chromeInIOS = /iapd|iphone|ipod/.test(ua) && /crios/.test(ua);
  var chromeInAndroid = isAndroid() && /chrome/.test(ua);
  return chromeInIOS || chromeInAndroid;
};

export let isFBApp = function () {
  var ua =
    global.navigator.userAgent || global.navigator.vendor || global.opera;
  return ua.indexOf('FBAN') > -1 || ua.indexOf('FBAV') > -1;
};

export let isSafari = function () {
  var safari = /version\/[\d\.]+.*safari/.test(ua);
  return !isMobileChrome() && safari;
};

export let isIE = function () {
  var ua = global.navigator.userAgent;

  // Test values; Uncomment to check result …

  // IE 10
  // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';

  // IE 11
  // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';

  // Edge 12 (Spartan)
  // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';

  // Edge 13
  // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

  var msie = ua.indexOf('MSIE ');
  if (msie > -1) {
    // IE 10 or older => return version number
    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
  }

  var trident = ua.indexOf('Trident/');
  if (trident > -1) {
    // IE 11 => return version number
    var rv = ua.indexOf('rv:');
    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
  }

  var edge = ua.indexOf('Edge/');
  if (edge > -1) {
    // Edge (IE 12+) => return version number
    return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
  }

  // other browser
  return false;
};

export const getViewWidth = function () {
  return (
    window.innerWidth ||
    document.body.clientWidth ||
    document.documentElement.clientWidth
  );
};

export const getViewHeight = function () {
  return (
    window.innerHeight ||
    document.body.clientHeight ||
    document.documentElement.clientHeight
  );
};

export const deviceDirectionPortrait = function () {
  let width = getViewWidth();
  let height = getViewHeight();
  return width <= 1024 && width / height < 1;
};

export const getPlatform = () => {
  try {
    if (navigator.userAgent.indexOf('Mac OS X') > -1) {
      return 'mac';
    }
    if (navigator.userAgent.indexOf('Windows') > -1) {
      return 'window';
    }
    if (navigator.userAgent.indexOf('iPhone') > -1) {
      return 'iPhone';
    }
    if (navigator.userAgent.indexOf('iPad') > -1) {
      return 'iPad';
    }
    if (navigator.userAgent.indexOf('Android') > -1) {
      return 'Android';
    }
  } catch (e) {}
  return 'Android';
};
